import { ROUTES_CREWS_LIST, ROUTES_UNAUTHORIZED } from '@/constants/routes';
import store from '@/store';
import { i18n } from '@/lang';

export default {
    name: ROUTES_CREWS_LIST,
    beforeEnter: guardRouteCrews,
    component: () => import(/*webpackChunkName: 'crews-page'*/ '@/views/crews/Crews.vue'),
    path: '/crews'
};

function guardRouteCrews(to, from, next) {
    if (store.getters.isSelectedClubIndividual || !store.getters.isClubDefaultSportWater) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}
